import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import emailjs from '@emailjs/browser';

const TURKIYE_SEHIRLER = ['Adana','Adıyaman','Afyonkarahisar','Ağrı','Amasya','Ankara','Antalya','Artvin','Aydın','Balıkesir','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum','Denizli','Diyarbakır','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Isparta','İçel (Mersin)','İstanbul','İzmir','Kars','Kastamonu','Kayseri','Kırklareli','Kırşehir','Kocaeli','Konya','Kütahya','Malatya','Manisa','Kahramanmaraş','Mardin','Muğla','Muş','Nevşehir','Niğde','Ordu','Rize','Sakarya','Samsun','Siirt','Sinop','Sivas','Tekirdağ','Tokat','Trabzon','Tunceli','Şanlıurfa','Uşak','Van','Yozgat','Zonguldak','Aksaray','Bayburt','Karaman','Kırıkkale','Batman','Şırnak','Bartın','Ardahan','Iğdır','Yalova','Karabük','Kilis','Osmaniye','Düzce'];

export default function SiparisOlustur() {
  const { profil } = useAuth();
  const navigate = useNavigate();
  const [adim, setAdim] = useState(1);

  const [firmalar, setFirmalar] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [depolar, setDepolar] = useState([]);
  const [stokMap, setStokMap] = useState({});

  const [seciliFirma, setSeciliFirma] = useState('');
  const [seciliGrup, setSeciliGrup] = useState('');
  const [seciliAltGrup, setSeciliAltGrup] = useState('');
  const [urunArama, setUrunArama] = useState('');
  const [sepet, setSepet] = useState([]);
  const [satisGrubu, setSatisGrubu] = useState({}); // urun_id -> 'veteriner' | 'hasta_yakini'

  const [entegreFiyatlar, setEntegreFiyatlar] = useState({});
  const [entegreFiyatAcik, setEntegreFiyatAcik] = useState({});
  const [musteriArama, setMusteriArama] = useState('');
  const [musteriSonuclar, setMusteriSonuclar] = useState([]);
  const [seciliMusteri, setSeciliMusteri] = useState(null);
  const [yeniMusteri, setYeniMusteri] = useState(false);
  const [musteriAraniyor, setMusteriAraniyor] = useState(false);
  const [borc, setBorc] = useState(null);          // {siparisler, toplam, enEskiGun}
  const [borcKontrolEdiliyor, setBorcKontrolEdiliyor] = useState(false);

  const [form, setForm] = useState({
    yeni_musteri_ad: '', yeni_musteri_tel: '', yeni_musteri_sehir: '', yeni_musteri_ilce: '', yeni_musteri_tip: 'vet_hekim',
    musteri_tipi: 'bireysel', depo_id: '', odeme_turu: 'banka', kdv_durumu: false,
    adres: '', not_: '', fatura_durumu: false, kargo_kodu: '', sehir: '',
    siparis_tipi: 'normal',
    broiler_satis_tipi: 'ciftlik', entegre_manuel_fiyat: '',
  });

  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [altTemsilciOran, setAltTemsilciOran] = useState(null); // null = normal/üst, sayı = alt temsilci pay oranı

  useEffect(() => { fetchIlkVeriler(); }, []);

  async function fetchIlkVeriler() {
    const [, { data: depoData }] = await Promise.all([
      fetchFirmalar(),
      supabase.from('depolar').select('id, ad, sehir').eq('aktif', true),
      profil?.id ? supabase.from('kullanicilar').select('ust_temsilci_id, alt_temsilci_komisyon_orani').eq('id', profil.id).maybeSingle().then(({ data }) => {
        if (data?.ust_temsilci_id) setAltTemsilciOran(data.alt_temsilci_komisyon_orani || 75);
      }) : Promise.resolve(),
    ]);
    setDepolar(depoData || []);
  }
  useEffect(() => { if (seciliFirma) fetchUrunler(); }, [seciliFirma]);
  useEffect(() => { if (form.depo_id && urunler.length > 0) fetchStoklar(); }, [form.depo_id, urunler]);

  useEffect(() => {
    if (musteriArama.length < 2) { setMusteriSonuclar([]); return; }
    const timer = setTimeout(() => araMusteri(musteriArama), 300);
    return () => clearTimeout(timer);
  }, [musteriArama]);

  async function araMusteri(q) {
    setMusteriAraniyor(true);
    let sorgu = supabase.from('musteriler').select('*').eq('aktif', true).limit(10);
    if (profil?.rol === 'temsilci') sorgu = sorgu.eq('temsilci_id', profil.id);
    sorgu = sorgu.or(`ad.ilike.%${q}%,telefon.ilike.%${q}%`);
    const { data } = await sorgu;
    setMusteriSonuclar(data || []);
    setMusteriAraniyor(false);
  }

  const BORC_GUN_LIMITI = 40;

  async function borcKontrol(musteriId) {
    setBorc(null);
    if (!musteriId) return;
    setBorcKontrolEdiliyor(true);
    const limit = new Date();
    limit.setDate(limit.getDate() - BORC_GUN_LIMITI);
    const { data, error } = await supabase.from('siparisler')
      .select('id, siparis_no, toplam_tutar, created_at')
      .eq('musteri_id', musteriId)
      .eq('odeme_durumu', 'odenmedi')
      .neq('siparis_tipi', 'numune')
      .not('siparis_durumu', 'eq', 'iptal')
      .lte('created_at', limit.toISOString())
      .order('created_at', { ascending: true });
    setBorcKontrolEdiliyor(false);
    if (error) { console.error('borc kontrol hatasi', error); return; }
    if (!data || data.length === 0) return;
    const bugun = Date.now();
    const gun = t => Math.floor((bugun - new Date(t).getTime()) / 86400000);
    setBorc({
      siparisler: data,
      toplam: data.reduce((a, b) => a + (Number(b.toplam_tutar) || 0), 0),
      enEskiGun: gun(data[0].created_at),
      gun,
    });
  }

  async function musteriSec(m) {
    setSeciliMusteri(m);
    setMusteriArama(m.ad);
    setMusteriSonuclar([]);
    borcKontrol(m.id);
    const { data: g } = await supabase.from('musteriler').select('adres, sehir, ilce, telefon').eq('id', m.id).single();
    const adres = g?.adres || m.adres || '';
    const rawSehir = g?.sehir || m.sehir || '';
    const sehirNorm = TURKIYE_SEHIRLER.find(s => s.toLowerCase() === rawSehir.toLowerCase()) || rawSehir;
    setForm(f => ({ ...f, adres, yeni_musteri_sehir: sehirNorm, yeni_musteri_ilce: m.ilce || '', sehir: sehirNorm }));
  }

  async function fetchFirmalar() {
    let q = supabase.from('firmalar').select('id, ad').eq('aktif', true);
    if (profil?.rol === 'temsilci') {
      const { data: yetkiler } = await supabase.from('temsilci_firma_yetki').select('firma_id').eq('kullanici_id', profil.id);
      const ids = (yetkiler || []).map(y => y.firma_id);
      if (ids.length > 0) q = q.in('id', ids);
    }
    const { data } = await q;
    const FIRMA_SIRA = {
      'acb52946-e2a8-4fac-84db-04865b85f944': 0,
      '5556578b-e620-4abc-837f-fb8549cfe512': 1,
      '408634a3-a463-43e8-b01e-2e55ce7ad9fb': 2,
    };
    const siralamali = (data || []).sort((a, b) => (FIRMA_SIRA[a.id] ?? 99) - (FIRMA_SIRA[b.id] ?? 99));
    setFirmalar(siralamali);
    if (siralamali?.length === 1) setSeciliFirma(siralamali[0].id);
  }

  async function fetchDepolar() {
    const { data } = await supabase.from('depolar').select('id, ad, sehir').eq('aktif', true);
    setDepolar(data || []);
  }

  async function fetchUrunler() {
    const { data } = await supabase.from('urunler').select('*').eq('firma_id', seciliFirma).eq('aktif', true).order('alt_grup').order('sira', { ascending: true }).order('ad');
    setUrunler(data || []);
  }

  async function fetchStoklar() {
    const { data } = await supabase.from('depo_stok').select('urun_id, miktar').eq('depo_id', form.depo_id);
    const map = {};
    (data || []).forEach(s => { map[s.urun_id] = s.miktar; });
    setStokMap(map);
  }

  function satisGrubuSec(urunId, grup) {
    setSatisGrubu(prev => ({ ...prev, [urunId]: grup }));
  }

  
const TURKIYE_ILCELER = {
  'Adana': ['Aladağ','Ceyhan','Çukurova','Feke','İmamoğlu','Karaisalı','Karataş','Kozan','Pozantı','Saimbeyli','Sarıçam','Seyhan','Tufanbeyli','Yumurtalık','Yüreğir'],
  'Ankara': ['Akyurt','Altındağ','Ayaş','Bala','Beypazarı','Çamlıdere','Çankaya','Çubuk','Elmadağ','Etimesgut','Evren','Gölbaşı','Güdül','Haymana','Kalecik','Kazan','Keçiören','Kızılcahamam','Mamak','Nallıhan','Polatlı','Pursaklar','Sincan','Şereflikoçhisar','Yenimahalle'],
  'İstanbul': ['Adalar','Arnavutköy','Ataşehir','Avcılar','Bağcılar','Bahçelievler','Bakırköy','Başakşehir','Bayrampaşa','Beşiktaş','Beykoz','Beylikdüzü','Beyoğlu','Büyükçekmece','Çatalca','Çekmeköy','Esenler','Esenyurt','Eyüpsultan','Fatih','Gaziosmanpaşa','Güngören','Kadıköy','Kağıthane','Kartal','Küçükçekmece','Maltepe','Pendik','Sancaktepe','Sarıyer','Silivri','Sultanbeyli','Sultangazi','Şile','Şişli','Tuzla','Ümraniye','Üsküdar','Zeytinburnu'],
  'İzmir': ['Aliağa','Balçova','Bayındır','Bayraklı','Bergama','Beydağ','Bornova','Buca','Çeşme','Çiğli','Dikili','Foça','Gaziemir','Güzelbahçe','Karabağlar','Karaburun','Karşıyaka','Kemalpaşa','Kınık','Kiraz','Konak','Menderes','Menemen','Narlıdere','Ödemiş','Seferihisar','Selçuk','Tire','Torbalı','Urla'],
  'Bursa': ['Büyükorhan','Gemlik','Gürsu','Harmancık','İnegöl','İznik','Karacabey','Keles','Kestel','Mudanya','Mustafakemalpaşa','Nilüfer','Orhaneli','Orhangazi','Osmangazi','Yenişehir','Yıldırım'],
  'Antalya': ['Aksu','Alanya','Demre','Döşemealtı','Elmalı','Finike','Gazipaşa','Gündoğmuş','İbradı','Kaş','Kemer','Kepez','Konyaaltı','Korkuteli','Kumluca','Manavgat','Muratpaşa','Serik'],
  'Konya': ['Ahırlı','Akören','Akşehir','Altınekin','Beyşehir','Bozkır','Cihanbeyli','Çeltik','Çumra','Derbent','Derebucak','Doğanhisar','Emirgazi','Ereğli','Güneysınır','Hadim','Halkapınar','Hüyük','Ilgın','Kadınhanı','Karapınar','Karatay','Kulu','Meram','Sarayönü','Selçuklu','Seydişehir','Taşkent','Tuzlukçu','Yalıhüyük','Yunak'],
  'Adıyaman': ['Besni','Çelikhan','Gerger','Gölbaşı','Kahta','Merkez','Samsat','Sincik','Tut'],
  'Afyonkarahisar': ['Başmakçı','Bayat','Bolvadin','Çay','Çobanlar','Dazkırı','Dinar','Emirdağ','Evciler','Hocalar','İhsaniye','İscehisar','Kızılören','Merkez','Sandıklı','Sinanpaşa','Sultandağı','Şuhut'],
  'Ağrı': ['Diyadin','Doğubayazıt','Eleşkirt','Hamur','Merkez','Patnos','Taşlıçay','Tutak'],
  'Aksaray': ['Ağaçören','Eskil','Gülağaç','Güzelyurt','Merkez','Ortaköy','Sarıyahşi','Sultanhanı'],
  'Amasya': ['Göynücek','Gümüşhacıköy','Hamamözü','Merkez','Merzifon','Suluova','Taşova'],
  'Artvin': ['Ardanuç','Arhavi','Borçka','Hopa','Kemalpaşa','Merkez','Murgul','Şavşat','Yusufeli'],
  'Aydın': ['Bozdoğan','Buharkent','Çine','Didim','Efeler','Germencik','İncirliova','Karacasu','Karpuzlu','Koçarlı','Köşk','Kuşadası','Kuyucak','Nazilli','Söke','Sultanhisar','Yenipazar'],
  'Balıkesir': ['Altıeylül','Ayvalık','Balya','Bandırma','Bigadiç','Burhaniye','Dursunbey','Edremit','Erdek','Gömeç','Gönen','Havran','İvrindi','Karesi','Kepsut','Manyas','Marmara','Savaştepe','Sındırgı','Susurluk'],
  'Bilecik': ['Bozüyük','Gölpazarı','İnhisar','Merkez','Osmaneli','Pazaryeri','Söğüt','Yenipazar'],
  'Bingöl': ['Adaklı','Genç','Karlıova','Kiğı','Merkez','Solhan','Yayladere','Yedisu'],
  'Bitlis': ['Adilcevaz','Ahlat','Güroymak','Hizan','Merkez','Mutki','Tatvan'],
  'Bolu': ['Dörtdivan','Gerede','Göynük','Kıbrıscık','Mengen','Merkez','Mudurnu','Seben','Yeniçağa'],
  'Burdur': ['Ağlasun','Altınyayla','Bucak','Çavdır','Çeltikçi','Gölhisar','Kemer','Merkez','Tefenni','Yeşilova'],
  'Çanakkale': ['Ayvacık','Bayramiç','Biga','Bozcaada','Çan','Eceabat','Ezine','Gelibolu','Gökçeada','Lapseki','Merkez','Yenice'],
  'Çankırı': ['Atkaracalar','Bayramören','Çerkeş','Eldivan','Ilgaz','Kızılırmak','Korgun','Kurşunlu','Merkez','Orta','Şabanözü','Yapraklı'],
  'Çorum': ['Alaca','Bayat','Boğazkale','Dodurga','İskilip','Kargı','Laçin','Mecitözü','Merkez','Oğuzlar','Ortaköy','Osmancık','Sungurlu','Uğurludağ'],
  'Denizli': ['Acıpayam','Babadağ','Baklan','Bekilli','Beyağaç','Bozkurt','Buldan','Çal','Çameli','Çardak','Çivril','Güney','Honaz','Kale','Merkezefendi','Pamukkale','Sarayköy','Serinhisar','Tavas'],
  'Diyarbakır': ['Bağlar','Bismil','Çermik','Çınar','Çüngüş','Dicle','Eğil','Ergani','Hani','Hazro','Kayapınar','Kocaköy','Kulp','Lice','Silvan','Sur','Yenişehir'],
  'Edirne': ['Enez','Havsa','İpsala','Keşan','Lalapaşa','Merkez','Meriç','Süloğlu','Uzunköprü'],
  'Elazığ': ['Ağın','Alacakaya','Arıcak','Baskil','Karakoçan','Keban','Kovancılar','Maden','Merkez','Palu','Sivrice'],
  'Erzincan': ['Çayırlı','İliç','Kemah','Kemaliye','Merkez','Otlukbeli','Refahiye','Tercan','Üzümlü'],
  'Erzurum': ['Aşkale','Aziziye','Çat','Hınıs','Horasan','İspir','Karaçoban','Karayazı','Köprüköy','Merkez','Narman','Oltu','Olur','Palandöken','Pasinler','Pazaryolu','Şenkaya','Tekman','Tortum','Uzundere','Yakutiye'],
  'Eskişehir': ['Alpu','Beylikova','Çifteler','Günyüzü','Han','İnönü','Mahmudiye','Mihalgazi','Mihalıççık','Odunpazarı','Sarıcakaya','Seyitgazi','Sivrihisar','Tepebaşı'],
  'Gaziantep': ['Araban','İslahiye','Karkamış','Nurdağı','Oğuzeli','Şahinbey','Şehitkamil','Yavuzeli'],
  'Giresun': ['Alucra','Bulancak','Çamoluk','Çanakçı','Dereli','Doğankent','Espiye','Eynesil','Görele','Güce','Keşap','Merkez','Piraziz','Şebinkarahisar','Tirebolu','Yağlıdere'],
  'Gümüşhane': ['Kelkit','Köse','Kürtün','Merkez','Şiran','Torul'],
  'Hakkari': ['Çukurca','Derecik','Merkez','Şemdinli','Yüksekova'],
  'Hatay': ['Altınözü','Antakya','Arsuz','Belen','Defne','Dörtyol','Erzin','Hassa','İskenderun','Kırıkhan','Kumlu','Payas','Reyhanlı','Samandağ','Yayladağı'],
  'Iğdır': ['Aralık','Karakoyunlu','Merkez','Tuzluca'],
  'Isparta': ['Aksu','Atabey','Eğirdir','Gelendost','Gönen','Keçiborlu','Merkez','Senirkent','Sütçüler','Şarkikaraağaç','Uluborlu','Yalvaç','Yenişarbademli'],
  'Kahramanmaraş': ['Afşin','Andırın','Çağlayancerit','Dulkadiroğlu','Ekinözü','Elbistan','Göksun','Merkez','Nurhak','Onikişubat','Pazarcık','Türkoğlu'],
  'Karabük': ['Eflani','Eskipazar','Merkez','Ovacık','Safranbolu','Yenice'],
  'Karaman': ['Ayrancı','Başyayla','Ermenek','Kazımkarabekir','Merkez','Sarıveliler'],
  'Kars': ['Akyaka','Arpaçay','Digor','Kağızman','Merkez','Sarıkamış','Selim','Susuz'],
  'Kastamonu': ['Abana','Ağlı','Araç','Azdavay','Bozkurt','Cide','Çatalzeytin','Daday','Devrekani','Doğanyurt','Hanönü','İhsangazi','İnebolu','Küre','Merkez','Pınarbaşı','Seydiler','Şenpazar','Taşköprü','Tosya'],
  'Kayseri': ['Akkışla','Bünyan','Develi','Felahiye','Hacılar','İncesu','Kocasinan','Melikgazi','Özvatan','Pınarbaşı','Sarıoğlan','Sarız','Talas','Tomarza','Yahyalı','Yeşilhisar'],
  'Kırıkkale': ['Bahşili','Balışeyh','Çelebi','Delice','Karakeçili','Keskin','Merkez','Sulakyurt','Yahşihan'],
  'Kırklareli': ['Babaeski','Demirköy','Kofçaz','Lüleburgaz','Merkez','Pehlivanköy','Pınarhisar','Vize'],
  'Kırşehir': ['Akçakent','Akpınar','Boztepe','Çiçekdağı','Kaman','Merkez','Mucur'],
  'Kilis': ['Elbeyli','Merkez','Musabeyli','Polateli'],
  'Kocaeli': ['Başiskele','Çayırova','Darıca','Derince','Dilovası','Gebze','Gölcük','İzmit','Kandıra','Karamürsel','Kartepe','Körfez'],
  'Kütahya': ['Altıntaş','Aslanapa','Çavdarhisar','Domaniç','Dumlupınar','Emet','Gediz','Hisarcık','Merkez','Pazarlar','Simav','Şaphane','Tavşanlı'],
  'Malatya': ['Akçadağ','Arapgir','Arguvan','Battalgazi','Darende','Doğanşehir','Doğanyol','Hekimhan','Kale','Kuluncak','Pütürge','Merkez','Yazıhan','Yeşilyurt'],
  'Manisa': ['Ahmetli','Akhisar','Alaşehir','Demirci','Gölmarmara','Gördes','Kırkağaç','Köprübaşı','Kula','Merkez','Sarıgöl','Saruhanlı','Selendi','Soma','Turgutlu','Yunusemre'],
  'Mardin': ['Artuklu','Dargeçit','Derik','Kızıltepe','Mazıdağı','Midyat','Nusaybin','Ömerli','Savur','Yeşilli'],
  'Mersin': ['Akdeniz','Anamur','Aydıncık','Bozyazı','Çamlıyayla','Erdemli','Gülnar','Mezitli','Mut','Silifke','Tarsus','Toroslar','Yenişehir'],
  'Muğla': ['Bodrum','Dalaman','Datça','Fethiye','Kavaklıdere','Köyceğiz','Marmaris','Menteşe','Milas','Ortaca','Seydikemer','Ula','Yatağan'],
  'Muş': ['Bulanık','Hasköy','Korkut','Malazgirt','Merkez','Varto'],
  'Nevşehir': ['Acıgöl','Avanos','Derinkuyu','Gülşehir','Hacıbektaş','Kozaklı','Merkez','Ürgüp'],
  'Niğde': ['Altunhisar','Bor','Çamardı','Çiftlik','Merkez','Ulukışla'],
  'Ordu': ['Akkuş','Altınordu','Aybastı','Çamaş','Çatalpınar','Çaybaşı','Fatsa','Gölköy','Gülyalı','Gürgentepe','İkizce','Kabadüz','Kabataş','Korgan','Kumru','Mesudiye','Perşembe','Ulubey','Ünye'],
  'Osmaniye': ['Bahçe','Düziçi','Hasanbeyli','Kadirli','Merkez','Sumbas','Toprakkale'],
  'Rize': ['Ardeşen','Çamlıhemşin','Çayeli','Derepazarı','Fındıklı','Güneysu','Hemşin','İkizdere','İyidere','Kalkandere','Merkez','Pazar'],
  'Sakarya': ['Adapazarı','Akyazı','Arifiye','Erenler','Ferizli','Geyve','Hendek','Karapürçek','Karasu','Kaynarca','Kocaali','Mithatpaşa','Pamukova','Sapanca','Serdivan','Söğütlü','Taraklı'],
  'Samsun': ['19 Mayıs','Alaçam','Asarcık','Atakum','Ayvacık','Bafra','Canik','Çarşamba','Havza','İlkadım','Kavak','Ladik','Salıpazarı','Tekkeköy','Terme','Vezirköprü','Yakakent'],
  'Siirt': ['Baykan','Eruh','Kurtalan','Merkez','Pervari','Şirvan','Tillo'],
  'Sinop': ['Ayancık','Boyabat','Dikmen','Durağan','Erfelek','Gerze','Merkez','Saraydüzü','Türkeli'],
  'Sivas': ['Akıncılar','Altınyayla','Divriği','Doğanşar','Gemerek','Gevrek','Gölova','Hafik','İmranlı','Kangal','Koyulhisar','Merkez','Suşehri','Şarkışla','Ulaş','Yıldızeli','Zara'],
  'Şanlıurfa': ['Akçakale','Birecik','Bozova','Ceylanpınar','Eyyübiye','Halfeti','Haliliye','Harran','Hilvan','Karaköprü','Siverek','Suruç','Viranşehir'],
  'Şırnak': ['Beytüşşebap','Cizre','Güçlükonak','İdil','Merkez','Silopi','Uludere'],
  'Tekirdağ': ['Çerkezköy','Çorlu','Ergene','Hayrabolu','Kapaklı','Malkara','Marmaraereğlisi','Merkez','Muratlı','Saray','Süleymanpaşa','Şarköy'],
  'Tokat': ['Almus','Artova','Başçiftlik','Erbaa','Merkez','Niksar','Pazar','Reşadiye','Sulusaray','Turhal','Yeşilyurt','Zile'],
  'Trabzon': ['Akçaabat','Araklı','Arsin','Beşikdüzü','Çarşıbaşı','Çaykara','Dernekpazarı','Düzköy','Hayrat','Köprübaşı','Maçka','Of','Ortahisar','Sürmene','Şalpazarı','Tonya','Vakfıkebir','Yomra'],
  'Tunceli': ['Çemişgezek','Hozat','Mazgirt','Merkez','Nazımiye','Ovacık','Pertek','Pülümür'],
  'Uşak': ['Banaz','Eşme','Karahallı','Merkez','Sivaslı','Ulubey'],
  'Van': ['Bahçesaray','Başkale','Çaldıran','Çatak','Edremit','Erciş','Gevaş','Gürpınar','İpekyolu','Merkez','Muradiye','Özalp','Saray','Tuşba'],
  'Yalova': ['Altınova','Armutlu','Çiftlikköy','Çınarcık','Merkez','Termal'],
  'Yozgat': ['Akdağmadeni','Aydıncık','Boğazlıyan','Çandır','Çayıralan','Çekerek','Kadışehri','Merkez','Saraykent','Sarıkaya','Sorgun','Şefaatli','Yenifakılı','Yerköy'],
  'Zonguldak': ['Alaplı','Çaycuma','Devrek','Ereğli','Gökçebey','Kilimli','Kozlu','Merkez'],
  'Batman': ['Beşiri','Gercüş','Hasankeyf','Kozluk','Merkez','Sason'],
  'Bayburt': ['Aydıntepe','Demirözü','Merkez'],
  'Ardahan': ['Çıldır','Damal','Göle','Hanak','Merkez','Posof'],
  'Bartın': ['Amasra','Kurucaşile','Merkez','Ulus'],
  'Düzce': ['Akçakoca','Cumayeri','Çilimli','Gölyaka','Gümüşova','Kaynaşlı','Merkez','Yığılca'],
  'Iğdır': ['Aralık','Karakoyunlu','Merkez','Tuzluca'],
  'Karabük': ['Eflani','Eskipazar','Merkez','Ovacık','Safranbolu','Yenice'],
  'Kilis': ['Elbeyli','Merkez','Musabeyli','Polateli'],
};
const FIPGL23_ID = 'acb52946-e2a8-4fac-84db-04865b85f944';
  const BROILER_ID = '408634a3-a463-43e8-b01e-2e55ce7ad9fb';

  function birimFiyat(urun) {
    if (urun.firma_id === BROILER_ID) {
      if (form.broiler_satis_tipi === 'ciftlik') return urun.ciftlik_fiyat || 0;
      if (form.broiler_satis_tipi === 'bayi') return urun.bayi_fiyat || 0;
      if (form.broiler_satis_tipi === 'entegre') return parseFloat(entegreFiyatlar[urun.id]) || 0;
      return urun.ciftlik_fiyat || 0;
    }
    const grup = satisGrubu[urun.id] || (urun.satis_tipi === 'hasta_yakini' ? 'hasta_yakini' : 'veteriner');
    if (urun.firma_id === FIPGL23_ID) {
      return grup === 'hasta_yakini' ? urun.hya_banka_fiyat : urun.banka_fiyat_kdvsiz;
    }
    if (form.odeme_turu === 'kredi_karti') {
      return grup === 'hasta_yakini' ? urun.hya_kk_fiyat : urun.kk_fiyat_kdvli;
    }
    return grup === 'hasta_yakini' ? urun.hya_banka_fiyat : urun.banka_fiyat_kdvsiz;
  }

  function komisyonHesapla(urun, miktar) {
    if (urun.komisyonsuz) return 0;
    const fiyat = birimFiyat(urun);
    let oran = 0;
    if (urun.firma_id === BROILER_ID) {
      if (form.broiler_satis_tipi === 'ciftlik') oran = urun.ciftlik_komisyon || 0;
      else if (form.broiler_satis_tipi === 'bayi') oran = urun.bayi_komisyon || 0;
      else if (form.broiler_satis_tipi === 'entegre') oran = urun.entegre_komisyon || 0;
    } else {
      oran = (urun.firma_id === FIPGL23_ID || form.musteri_tipi !== 'kurumsal')
        ? urun.bireysel_komisyon : urun.kurumsal_komisyon;
    }
    return ((fiyat * miktar) * ((oran || 0) / 100));
  }

  function sepeteEkleDetay(urun, grup, odemeTuru) {
    if (!form.depo_id) { setHata('Lütfen önce depo seçin!'); return; }
    const stok = stokMap[urun.id];
    if (stok === undefined || stok === 0) { setHata('⛔ "' + urun.ad + '" ürününün depoda stoğu YOK.'); return; }
    setHata('');
    const gGrup = grup || satisGrubu[urun.id] || 'veteriner';
    const gTuru = odemeTuru || form.odeme_turu;
    let fiyat = 0;
    if (urun.firma_id === FIPGL23_ID) {
      fiyat = gGrup === 'hasta_yakini' ? (urun.hya_banka_fiyat || 0) : (urun.banka_fiyat_kdvsiz || 0);
    } else if (urun.firma_id === BROILER_ID) {
      if (form.broiler_satis_tipi === 'ciftlik') fiyat = urun.ciftlik_fiyat || 0;
      else if (form.broiler_satis_tipi === 'bayi') fiyat = urun.bayi_fiyat || 0;
      else fiyat = parseFloat(entegreFiyatlar[urun.id]) || 0;
    } else {
      if (gTuru === 'kredi_karti') fiyat = gGrup === 'hasta_yakini' ? (urun.hya_kk_fiyat || 0) : (urun.kk_fiyat_kdvli || 0);
      else fiyat = gGrup === 'hasta_yakini' ? (urun.hya_banka_fiyat || 0) : (urun.banka_fiyat_kdvsiz || 0);
    }
    // FIX: Komisyon oranı gruba göre seçilmeli
    // HY (hasta yakini) için hya komisyon oranı varsa onu kullan, yoksa bireysel
    let komisyonOrani = 0;
    if (urun.firma_id === BROILER_ID) {
      if (form.broiler_satis_tipi === 'ciftlik') komisyonOrani = urun.ciftlik_komisyon || 0;
      else if (form.broiler_satis_tipi === 'bayi') komisyonOrani = urun.bayi_komisyon || 0;
      else komisyonOrani = urun.entegre_komisyon || 0;
    } else if (urun.firma_id === FIPGL23_ID) {
      // FIPGL23: her zaman bireysel komisyon
      komisyonOrani = urun.bireysel_komisyon || 0;
    } else {
      // Vitanimal vb: ödeme türü KK ise kurumsal_komisyon, banka/elden ise bireysel_komisyon
      // bireysel_komisyon = Banka/Elden oranı
      // kurumsal_komisyon = Kredi Kartı oranı
      if (gTuru === 'kredi_karti') {
        komisyonOrani = gGrup === 'hasta_yakini'
          ? (urun.hya_kurumsal_komisyon || urun.kurumsal_komisyon || 0)
          : (urun.kurumsal_komisyon || 0);
      } else {
        komisyonOrani = gGrup === 'hasta_yakini'
          ? (urun.hya_bireysel_komisyon || urun.bireysel_komisyon || 0)
          : (urun.bireysel_komisyon || 0);
      }
    }
    const komisyon = urun.komisyonsuz ? 0 : fiyat * (komisyonOrani / 100);
    const sepetKey = urun.id + '_' + gGrup + '_' + gTuru;
    setSepet(prev => {
      const mevcut = prev.find(i => i.sepetKey === sepetKey);
      if (mevcut) return prev.map(i => i.sepetKey === sepetKey
        ? { ...i, miktar: i.miktar + 1, komisyon: urun.komisyonsuz ? 0 : fiyat * (i.miktar + 1) * (komisyonOrani / 100) } : i);
      return [...prev, { sepetKey, urun, miktar: 1, fiyat, komisyon, komisyonOrani, grup: gGrup, odemeTuru: gTuru }];
    });
  }

  function sepeteEkle(urun) {
    if (!form.depo_id) { setHata('Lütfen önce depo seçin!'); return; }
    const stok = stokMap[urun.id];
    if (stok === undefined || stok === 0) { setHata(`⛔ "${urun.ad}" ürününün depoda stoğu YOK.`); return; }
    setHata('');
    const fiyat = birimFiyat(urun);
    const komisyon = komisyonHesapla(urun, 1);
    setSepet(prev => {
      const mevcut = prev.find(i => i.urun.id === urun.id);
      if (mevcut) return prev.map(i => i.urun.id === urun.id ? { ...i, miktar: i.miktar + 1, fiyat, komisyon: komisyonHesapla(urun, i.miktar + 1) } : i);
      return [...prev, { urun, miktar: 1, fiyat, komisyon, komisyonOrani: form.musteri_tipi === 'kurumsal' ? urun.kurumsal_komisyon : urun.bireysel_komisyon }];
    });
  }

  function sepetMiktarGuncelle(urunId, yeniMiktar) {
    const miktar = parseInt(yeniMiktar);
    if (isNaN(miktar) || miktar <= 0) {
      setSepet(prev => prev.filter(i => i.urun.id !== urunId));
      return;
    }
    setSepet(prev => prev.map(i => {
      if (i.urun.id !== urunId) return i;
      return { ...i, miktar, komisyon: komisyonHesapla(i.urun, miktar) };
    }));
  }

  function hesapla() {
    let tutar = 0, komisyonTam = 0, maliyet = 0;
    for (const item of sepet) {
      tutar += item.fiyat * item.miktar;
      komisyonTam += item.komisyon || 0;
      maliyet += (item.urun?.maliyet || 0) * item.miktar;
    }
    // Numune siparişinde komisyon yok
    if (form.siparis_tipi === 'numune') komisyonTam = 0;
    const komisyonGoster = altTemsilciOran !== null ? komisyonTam * (altTemsilciOran / 100) : komisyonTam;
    const kar = tutar - komisyonTam - maliyet;
    return { tutar, komisyon: komisyonTam, komisyonGoster, maliyet, kar };
  }

  const { tutar, komisyon, komisyonGoster, maliyet, kar } = hesapla();

  const altGruplar = [...new Set(urunler.map(u => (u.alt_grup || 'Diğer').trim()))].sort();

  const filtreliUrunler = urunler.filter(u => {
    if (urunArama && !u.ad.toLowerCase().includes(urunArama.toLowerCase())) return false;
    if (seciliAltGrup && (u.alt_grup || 'Diğer').trim() !== seciliAltGrup) return false;
    return true;
  });

  const stokUyari = form.depo_id ? sepet.filter(item => {
    const stok = stokMap[item.urun?.id];
    return stok !== undefined && stok < item.miktar;
  }).map(item => `${item.urun?.ad}: Stokta ${stokMap[item.urun?.id]} adet var, ${item.miktar} adet istendi`) : [];

  const isTemsilci = profil?.rol === 'temsilci';
  const yetkiliRol = profil?.rol === 'admin' || profil?.rol === 'super_admin';

  async function handleKaydet() {
    if (!form.depo_id) { setHata('Lütfen depo seçin!'); return; }
    if (sepet.length === 0) { setHata('Sepet boş!'); return; }
    if (!yeniMusteri && !seciliMusteri) { setHata('Müşteri seçin!'); return; }
    if (yeniMusteri && !form.yeni_musteri_ad) { setHata('Müşteri adı girin!'); return; }

    // 30 gunu gecmis odenmemis siparisi olan musteriye yeni siparis acilamaz
    if (borc && borc.siparisler.length > 0) {
      if (yetkiliRol) {
        const onay = window.confirm(
          `DİKKAT: ${seciliMusteri?.ad} müşterisinin ${borc.siparisler.length} adet ödenmemiş siparişi var.\n` +
          `Toplam borç: ${borc.toplam.toLocaleString('tr-TR')} ₺ (en eskisi ${borc.enEskiGun} gün gecikmiş)\n\n` +
          `Yönetici yetkisiyle bu engeli aşmak istiyor musunuz?`
        );
        if (!onay) return;
      } else {
        setHata(
          `Bu müşterinin ${BORC_GUN_LIMITI} günü geçmiş ${borc.siparisler.length} adet ödenmemiş siparişi var ` +
          `(toplam ${borc.toplam.toLocaleString('tr-TR')} ₺). Ödeme alınmadan yeni sipariş açılamaz.`
        );
        return;
      }
    }

    setYukleniyor(true);
    setHata('');

    try {
      let musteri_id = seciliMusteri?.id;

      if (yeniMusteri) {
        const { data: ym, error: yhe } = await supabase.from('musteriler').insert({
          ad: form.yeni_musteri_ad, telefon: form.yeni_musteri_tel,
          sehir: form.yeni_musteri_sehir, ilce: form.yeni_musteri_ilce, musteri_tipi: form.yeni_musteri_tip, adres: form.adres,
          temsilci_id: profil?.id
        }).select().single();
        if (yhe) throw yhe;
        musteri_id = ym.id;
      }

      if (musteri_id && form.adres) {
        await supabase.from('musteriler').update({ adres: form.adres }).eq('id', musteri_id);
      }

      const { data: siparis, error: se } = await supabase.from('siparisler').insert({
        musteri_id, temsilci_id: profil?.id, depo_id: form.depo_id,
        firma_id: seciliFirma, odeme_turu: form.odeme_turu, kdv_durumu: form.kdv_durumu,
        musteri_tipi: form.musteri_tipi, toplam_tutar: tutar,
        toplam_komisyon: form.siparis_tipi === 'numune' ? 0 : komisyon,
        toplam_maliyet: maliyet, net_kar: kar, adres: form.adres, not_: form.not_,
        fatura_durumu: form.fatura_durumu, kargo_kodu: form.kargo_kodu,
        siparis_tipi: form.siparis_tipi,
      }).select().single();
      if (se) throw se;

      const kalemler = sepet.map(item => ({
        siparis_id: siparis.id,
        urun_id: item.urun.id,
        miktar: item.miktar,
        birim_fiyat: item.fiyat,
        komisyon_orani: item.komisyonOrani || 0,
        komisyon_tutari: item.komisyon || 0,
        maliyet: item.urun.maliyet || 0,
        toplam: item.fiyat * item.miktar,
      }));

      const { error: kalemErr } = await supabase.from('siparis_kalemleri').insert(kalemler);
      if (kalemErr) console.error('siparis_kalemleri insert error:', kalemErr);

      // Stok güncellemelerini paralel yap
      await Promise.all(sepet.map(async item => {
        const { data: stok } = await supabase.from('depo_stok').select('miktar').eq('depo_id', form.depo_id).eq('urun_id', item.urun.id).maybeSingle();
        const onceki = Number(stok?.miktar) || 0;
        const yeni = Math.max(0, onceki - item.miktar);
        await Promise.all([
          supabase.from('depo_stok').upsert({ depo_id: form.depo_id, urun_id: item.urun.id, miktar: yeni }, { onConflict: 'depo_id,urun_id' }),
          supabase.from('stok_hareketleri').insert({ depo_id: form.depo_id, urun_id: item.urun.id, hareket_tipi: 'cikis', miktar: item.miktar, onceki_stok: onceki, sonraki_stok: yeni, siparis_id: siparis.id, yapan: profil?.id }),
        ]);
      }));

      // Mail gönder
      // Üst temsilci varsa komisyon payını kaydet
      try {
        const { data: temsilciData } = await supabase
          .from('kullanicilar')
          .select('ust_temsilci_id, alt_temsilci_komisyon_orani')
          .eq('id', profil?.id)
          .single();

        if (temsilciData?.ust_temsilci_id) {
          const altOran = temsilciData.alt_temsilci_komisyon_orani || 75;
          const ustOran = 100 - altOran;
          const ustPay = komisyon * (ustOran / 100);
          const altPay = komisyon * (altOran / 100);

          await supabase.from('ust_temsilci_komisyonlar').insert({
            siparis_id: siparis.id,
            ust_temsilci_id: temsilciData.ust_temsilci_id,
            alt_temsilci_id: profil?.id,
            toplam_komisyon: komisyon,
            ust_temsilci_payi: ustPay,
            alt_temsilci_payi: altPay,
          });

          // Siparişe gerçek komisyon miktarını güncelle (alt temsilcinin payı)
          await supabase.from('siparisler').update({
            toplam_komisyon: altPay,
            net_kar: tutar - altPay - maliyet,
          }).eq('id', siparis.id);
        }
      } catch (ustErr) {
        console.error('Üst temsilci komisyon hatası:', ustErr);
      }

      try {
        emailjs.init('SThZhgM7_oNjiAa72');
        await emailjs.send('service_tlwaq1p', 'template_usp871b', {
          to_email: 'fipwars01@gmail.com',
          musteri_adi: yeniMusteri ? form.yeni_musteri_ad : (seciliMusteri?.ad || ''),
          temsilci_adi: (profil?.ad || '') + ' ' + (profil?.soyad || ''),
          urunler: sepet.map(i => i.urun.ad + ' x' + i.miktar).join(', '),
          toplam: tutar.toLocaleString('tr-TR'),
          depo: depolar.find(d => d.id === form.depo_id)?.ad || '',
          tarih: new Date().toLocaleString('tr-TR'),
        }, 'SThZhgM7_oNjiAa72');
      } catch (mailErr) {
        console.error('Mail gönderilemedi:', mailErr);
      }

      navigate('/siparisler');
    } catch (err) {
      setHata(err.message || 'Hata oluştu');
    }
    setYukleniyor(false);
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Sipariş Oluştur</h1>
          <p className="page-subtitle">Adım {adim}/2 — {adim === 1 ? 'Ürün Seçimi' : 'Müşteri & Detaylar'}</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {adim === 2 && <button className="btn btn-ghost" onClick={() => setAdim(1)}>← Geri</button>}
          <button className="btn btn-ghost" onClick={() => navigate('/siparisler')}>İptal</button>
        </div>
      </div>

      {hata && <div className="alert alert-error" style={{ marginBottom: 12 }}>{hata}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 20 }}>
        <div>
          {adim === 1 && (
            <div className="card">
              <h3 style={{ marginBottom: 16, fontSize: 15, fontWeight: 700 }}>Ürün Seçimi</h3>
              <div className="form-row cols-2" style={{ marginBottom: 12 }}>
                <div className="form-group">
                  <label className="label">Firma</label>
                  <select className="select" value={seciliFirma} onChange={e => { setSeciliFirma(e.target.value); setSeciliGrup(''); setSeciliAltGrup(''); }}>
                    <option value="">Firma Seçin</option>
                    {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="label">Ürün Ara</label>
                  <input className="input" placeholder="Ürün adı..." value={urunArama} onChange={e => setUrunArama(e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="label">Depo *</label>
                  <select className="select" value={form.depo_id} onChange={e => setForm(f => ({ ...f, depo_id: e.target.value }))}>
                    <option value="">Depo Seçin</option>
                    {depolar.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
                  </select>
                </div>
              </div>
              {seciliFirma && (
                <div style={{ marginBottom: 16 }}>
                  <label className="label">Alt Grup</label>
                  <select className="select" value={seciliAltGrup} onChange={e => setSeciliAltGrup(e.target.value)}>
                    <option value="">Tümü</option>
                    {altGruplar.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </div>
              )}

              {/* BROILER: Satış Tipi Seçimi */}
              {seciliFirma === BROILER_ID && (
                <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 14, marginBottom: 16 }}>
                  <div className="label" style={{ marginBottom: 10 }}>Satış Tipi *</div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: form.broiler_satis_tipi === 'entegre' ? 12 : 0 }}>
                    {[
                      { val: 'ciftlik', label: '🐔 Çiftlik' },
                      { val: 'bayi', label: '🏪 Bayi' },
                      { val: 'entegre', label: '🏭 Entegre Tesis' },
                    ].map(({ val, label }) => (
                      <button key={val}
                        className={`btn btn-sm ${form.broiler_satis_tipi === val ? 'btn-primary' : 'btn-ghost'}`}
                        onClick={() => {
                          setForm(f => ({ ...f, broiler_satis_tipi: val, musteri_tipi: val, entegre_manuel_fiyat: '' }));
                          setEntegreFiyatlar({});
                          setEntegreFiyatAcik({});
                          setSepet([]); // Fiyat değiştiği için sepeti temizle
                        }}>
                        {label}
                      </button>
                    ))}
                  </div>
                  {form.broiler_satis_tipi === 'entegre' && (
                    <div style={{ marginTop: 12 }}>
                      <label className="label">Birim Fiyat (₺) *</label>
                      <input
                        className="input"
                        type="number"
                        step="0.01"
                        placeholder="Entegre tesis satış fiyatını girin..."
                        value={form.entegre_manuel_fiyat}
                        onChange={e => {
                          setForm(f => ({ ...f, entegre_manuel_fiyat: e.target.value }));
                          setSepet([]); // Fiyat değişince sepeti sıfırla
                        }}
                      />
                      <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>Bu fiyat sepetteki tüm entegre ürünlere uygulanır</div>
                    </div>
                  )}
                </div>
              )}
              <table className="table">
                <thead>
                  <tr><th>Ürün</th><th>Grup</th><th>Fiyat Seç & Ekle</th></tr>
                </thead>
                <tbody>
                  {!seciliFirma ? (
                    <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Firma seçin</td></tr>
                  ) : filtreliUrunler.length === 0 ? (
                    <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Ürün bulunamadı</td></tr>
                  ) : filtreliUrunler.length === 0 ? (
                    <tr><td colSpan={3} style={{ textAlign: 'center', padding: 20, color: 'var(--text2)' }}>Ürün bulunamadı</td></tr>
                ) : altGruplar.filter(g => filtreliUrunler.some(u => (u.alt_grup || 'Diğer').trim() === g)).map(g => (
                  <>
                    <tr key={'g_' + g}>
                      <td colSpan={3} style={{ background: 'var(--bg3)', padding: '6px 12px', fontWeight: 700, fontSize: 12, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: 1 }}>📂 {g}</td>
                    </tr>
                    {filtreliUrunler.filter(u => (u.alt_grup || 'Diğer').trim() === g).map(u => (
                    <tr key={u.id}>
                      <td>
                        <div style={{ fontWeight: 500 }}>{u.ad}</div>
                        {form.depo_id && (
                          <div style={{ fontSize: 11, marginTop: 2 }}>
                            {stokMap[u.id] === undefined ? (
                              <span style={{ color: 'var(--text2)' }}>Stok bilgisi yok</span>
                            ) : stokMap[u.id] === 0 ? (
                              <span style={{ color: 'var(--red)', fontWeight: 600 }}>⛔ Stok Yok</span>
                            ) : stokMap[u.id] <= 5 ? (
                              <span style={{ color: 'var(--yellow)', fontWeight: 600 }}>⚠️ Az Stok: {stokMap[u.id]} adet</span>
                            ) : (
                              <span style={{ color: 'var(--green)' }}>✓ Stok: {stokMap[u.id]} adet</span>
                            )}
                          </div>
                        )}
                      </td>
                      <td style={{ color: 'var(--text2)', fontSize: 12 }}>{u.alt_grup || u.grup}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                          {/* BROILER */}
                          {seciliFirma === BROILER_ID && (
                            form.broiler_satis_tipi === 'entegre' ? (
                              entegreFiyatAcik[u.id] ? (
                                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                  <input className="input" type="number" step="0.01" placeholder="Fiyat..." value={entegreFiyatlar[u.id] || ''} onChange={e => setEntegreFiyatlar(p => ({ ...p, [u.id]: e.target.value }))} style={{ width: 90, padding: '4px 8px' }} autoFocus />
                                  <button className="btn btn-primary btn-sm" onClick={() => { const f2 = parseFloat(entegreFiyatlar[u.id]); if (!f2) return; setEntegreFiyatAcik(p => ({ ...p, [u.id]: false })); sepeteEkle(u); }}>✓</button>
                                  <button className="btn btn-ghost btn-sm" onClick={() => setEntegreFiyatAcik(p => ({ ...p, [u.id]: false }))}>✕</button>
                                </div>
                              ) : (
                                <button className="btn btn-primary btn-sm" disabled={stokMap[u.id] === 0} onClick={() => setEntegreFiyatAcik(p => ({ ...p, [u.id]: true }))}>
                                  {stokMap[u.id] === 0 ? '⛔ Stok Yok' : '💰 Fiyat Gir'}
                                </button>
                              )
                            ) : (
                              <button className={`btn btn-sm ${stokMap[u.id] === 0 ? 'btn-ghost' : 'btn-primary'}`} disabled={stokMap[u.id] === 0} onClick={() => sepeteEkle(u)}>
                                {stokMap[u.id] === 0 ? '⛔ Stok Yok' : `+ ${(birimFiyat(u)).toLocaleString('tr-TR')} ₺`}
                              </button>
                            )
                          )}
                          {/* FIPGL23 — Vet + HY */}
                          {seciliFirma === FIPGL23_ID && (
                            stokMap[u.id] === 0 ? <span style={{ color: 'var(--red)', fontWeight: 600 }}>⛔ Stok Yok</span> : (<>
                              <button className="btn btn-primary btn-sm" onClick={() => sepeteEkleDetay(u, 'veteriner', 'banka')}>
                                Vet. {(u.banka_fiyat_kdvsiz || 0).toLocaleString('tr-TR')} ₺
                              </button>
                              {(u.satis_tipi || '').trim() === 'hepsi' && (
                                <button className="btn btn-ghost btn-sm" onClick={() => sepeteEkleDetay(u, 'hasta_yakini', 'banka')}>
                                  HY {(u.hya_banka_fiyat || 0).toLocaleString('tr-TR')} ₺
                                </button>
                              )}
                            </>)
                          )}
                          {/* Vitanimal vb — Vet Banka + Vet KK + HY Banka + HY KK */}
                          {seciliFirma !== FIPGL23_ID && seciliFirma !== BROILER_ID && (
                            stokMap[u.id] === 0 ? <span style={{ color: 'var(--red)', fontWeight: 600 }}>⛔ Stok Yok</span> : (<>
                              <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }} onClick={() => sepeteEkleDetay(u, 'veteriner', 'banka')}>
                                Vet.Banka {(u.banka_fiyat_kdvsiz || 0).toLocaleString('tr-TR')} ₺
                              </button>
                              <button className="btn btn-ghost btn-sm" style={{ fontSize: 11, color: 'var(--yellow)', borderColor: 'var(--yellow)' }} onClick={() => sepeteEkleDetay(u, 'veteriner', 'kredi_karti')}>
                                Vet.KK {(u.kk_fiyat_kdvli || 0).toLocaleString('tr-TR')} ₺
                              </button>
                              {(u.satis_tipi || '').trim() === 'hepsi' && (<>
                                <button className="btn btn-ghost btn-sm" style={{ fontSize: 11 }} onClick={() => sepeteEkleDetay(u, 'hasta_yakini', 'banka')}>
                                  HY.Banka {(u.hya_banka_fiyat || 0).toLocaleString('tr-TR')} ₺
                                </button>
                                <button className="btn btn-ghost btn-sm" style={{ fontSize: 11, color: 'var(--yellow)', borderColor: 'var(--yellow)' }} onClick={() => sepeteEkleDetay(u, 'hasta_yakini', 'kredi_karti')}>
                                  HY.KK {(u.hya_kk_fiyat || 0).toLocaleString('tr-TR')} ₺
                                </button>
                              </>)}
                            </>)
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                  </>
                ))}
                </tbody>
              </table>
            </div>
          )}

          {adim === 2 && (
            <div className="card">
              <h3 style={{ marginBottom: 16, fontSize: 15, fontWeight: 700 }}>Müşteri & Sipariş Detayları</h3>
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                  <button className={`btn ${!yeniMusteri ? 'btn-primary' : 'btn-ghost'} btn-sm`} onClick={() => { setYeniMusteri(false); setSeciliMusteri(null); setMusteriArama(''); setBorc(null); }}>Mevcut Müşteri</button>
                  <button className={`btn ${yeniMusteri ? 'btn-primary' : 'btn-ghost'} btn-sm`} onClick={() => { setYeniMusteri(true); setSeciliMusteri(null); setBorc(null); }}>+ Yeni Müşteri</button>
                </div>
                {!yeniMusteri ? (
                  <div style={{ position: 'relative' }}>
                    <input className="input" placeholder="Müşteri adı veya telefon..." value={musteriArama} onChange={e => { setMusteriArama(e.target.value); setSeciliMusteri(null); setBorc(null); }} autoComplete="off" />
                    {musteriAraniyor && <div style={{ padding: 10, color: 'var(--text2)', fontSize: 13 }}>Aranıyor...</div>}
                    {musteriSonuclar.length > 0 && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100, background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow)', maxHeight: 220, overflowY: 'auto' }}>
                        {musteriSonuclar.map(m => (
                          <div key={m.id} onClick={() => musteriSec(m)}
                            style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            onMouseOver={e => e.currentTarget.style.background = 'var(--bg3)'}
                            onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
                            <div>
                              <span style={{ fontWeight: 600 }}>{m.ad}</span>
                              <span style={{ fontSize: 11, color: 'var(--text2)', marginLeft: 8 }}>{m.musteri_tipi}</span>
                            </div>
                            <span style={{ fontSize: 12, color: 'var(--text2)' }}>{m.sehir} • {m.telefon}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {seciliMusteri && (
                      <>
                        <div style={{ marginTop: 8, padding: '8px 12px', background: 'rgba(224,123,0,0.1)', border: '1px solid var(--accent)', borderRadius: 'var(--r)', display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontWeight: 600, color: 'var(--accent)' }}>✓ {seciliMusteri.ad}</span>
                          <span style={{ fontSize: 12, color: 'var(--text2)' }}>{seciliMusteri.sehir} • {seciliMusteri.telefon}</span>
                        </div>
                        {borcKontrolEdiliyor && (
                          <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text2)' }}>Ödeme geçmişi kontrol ediliyor...</div>
                        )}
                        {borc && (
                          <div style={{ marginTop: 8, padding: '12px 14px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.5)', borderRadius: 'var(--r)' }}>
                            <div style={{ fontWeight: 800, color: 'var(--red)', marginBottom: 4 }}>
                              🚫 Ödeme Engeli — {BORC_GUN_LIMITI} günü geçmiş {borc.siparisler.length} ödenmemiş sipariş
                            </div>
                            <div style={{ fontSize: 13, marginBottom: 8 }}>
                              Toplam borç: <b>{borc.toplam.toLocaleString('tr-TR')} ₺</b>
                              <span style={{ color: 'var(--text2)' }}> • en eskisi {borc.enEskiGun} gün gecikmiş</span>
                            </div>
                            <div style={{ maxHeight: 130, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
                              {borc.siparisler.map(b => (
                                <div key={b.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, background: 'var(--bg)', padding: '5px 9px', borderRadius: 6 }}>
                                  <span style={{ fontFamily: 'monospace', fontWeight: 700 }}>{b.siparis_no}</span>
                                  <span style={{ color: 'var(--text2)' }}>{borc.gun(b.created_at)} gün</span>
                                  <span style={{ fontWeight: 700 }}>{Number(b.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</span>
                                </div>
                              ))}
                            </div>
                            <div style={{ fontSize: 12, marginTop: 8, color: yetkiliRol ? 'var(--text2)' : 'var(--red)', fontWeight: 600 }}>
                              {yetkiliRol
                                ? 'Yönetici olarak onay vererek yine de sipariş açabilirsiniz.'
                                : 'Ödeme alınmadan bu müşteriye yeni sipariş açılamaz.'}
                            </div>
                          </div>
                        )}
                        <div className="form-group" style={{ marginTop: 8 }}>
                          <label className="label">Şehir</label>
                          <select className="select" value={form.sehir} onChange={e => setForm(f => ({ ...f, sehir: e.target.value }))}>
                            <option value="">Şehir seçin...</option>
                            {TURKIYE_SEHIRLER.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </div>
                      </>
                    )}
                    {musteriArama.length >= 2 && musteriSonuclar.length === 0 && !musteriAraniyor && !seciliMusteri && (
                      <div style={{ marginTop: 8, padding: '8px 12px', background: 'var(--bg3)', borderRadius: 'var(--r)', fontSize: 13, color: 'var(--text2)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Müşteri bulunamadı</span>
                        <button className="btn btn-primary btn-sm" onClick={() => { setYeniMusteri(true); setForm(f => ({ ...f, yeni_musteri_ad: musteriArama })); }}>+ Yeni Ekle</button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="form-row cols-2">
                    <div className="form-group"><label className="label">Ad Soyad *</label><input className="input" value={form.yeni_musteri_ad} onChange={e => setForm(f => ({ ...f, yeni_musteri_ad: e.target.value }))} autoComplete="off" /></div>
                    <div className="form-group"><label className="label">Telefon</label><input className="input" value={form.yeni_musteri_tel} onChange={e => setForm(f => ({ ...f, yeni_musteri_tel: e.target.value }))} autoComplete="off" maxLength={15} /></div>
                    <div className="form-group">
                      <label className="label">Müşteri Tipi</label>
                      <select className="select" value={form.yeni_musteri_tip} onChange={e => setForm(f => ({ ...f, yeni_musteri_tip: e.target.value }))}>
                        <option value="vet_hekim">Vet. Hekim</option>
                        <option value="bireysel">Bireysel</option>
                        <option value="bayi">Bayi</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ position: 'relative' }}>
                      <label className="label">Şehir</label>
                      <input
                        className="input"
                        placeholder="Şehir ara... (İ, M, S...)"
                        value={form.yeni_musteri_sehir}
                        onChange={e => setForm(f => ({ ...f, yeni_musteri_sehir: e.target.value }))}
                        autoComplete="off"
                      />
                      {form.yeni_musteri_sehir.length >= 1 && !TURKIYE_SEHIRLER.includes(form.yeni_musteri_sehir) && (
                        <div style={{
                          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999,
                          background: 'var(--bg2)', border: '1px solid var(--border)',
                          borderRadius: 'var(--r)', maxHeight: 200, overflowY: 'auto',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                        }}>
                          {TURKIYE_SEHIRLER
                            .filter(s => {
                              const normalize = str => str.toLocaleLowerCase('tr-TR').replace(/İ/g,'i').replace(/I/g,'ı');
                              return normalize(s).startsWith(normalize(form.yeni_musteri_sehir));
                            })
                            .slice(0, 10)
                            .map(s => (
                              <div key={s}
                                style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--border)', fontSize: 14 }}
                                onMouseDown={() => setForm(f => ({ ...f, yeni_musteri_sehir: s }))}
                                onTouchStart={() => setForm(f => ({ ...f, yeni_musteri_sehir: s }))}>
                                {s}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* İlçe alanı */}
              {yeniMusteri && (
                <div className="form-group" style={{ position: 'relative' }}>
                  <label className="label">İlçe</label>
                  <input className="input" placeholder="Kadıköy, Çankaya..."
                    value={form.yeni_musteri_ilce || ''}
                    onChange={e => setForm(f => ({ ...f, yeni_musteri_ilce: e.target.value }))}
                    autoComplete="off" />
                  {form.yeni_musteri_ilce && form.yeni_musteri_sehir && !TURKIYE_ILCELER[form.yeni_musteri_sehir]?.includes(form.yeni_musteri_ilce) && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 'var(--r)', zIndex: 999, maxHeight: 200, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                      {(TURKIYE_ILCELER[form.yeni_musteri_sehir] || [])
                        .filter(i => i.toLocaleLowerCase('tr-TR').includes(form.yeni_musteri_ilce.toLocaleLowerCase('tr-TR')))
                        .map(i => (
                          <div key={i} style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 14, borderBottom: '1px solid var(--border)' }}
                            onMouseDown={e => { e.preventDefault(); setForm(f => ({ ...f, yeni_musteri_ilce: i })); }}>
                            {i}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              )}

              <div className="form-row cols-2">
                <div className="form-group">
                  <label className="label">Müşteri Tipi (Komisyon)</label>
                  <select className="select" value={form.musteri_tipi}
                    disabled={seciliFirma === BROILER_ID}
                    onChange={e => setForm(f => ({ ...f, musteri_tipi: e.target.value }))}>
                    {seciliFirma === BROILER_ID ? (
                      <>
                        <option value="ciftlik">Çiftlik</option>
                        <option value="bayi">Bayi</option>
                        <option value="entegre">Entegre Tesis</option>
                      </>
                    ) : (
                      <>
                        <option value="bireysel">Bireysel</option>
                        {seciliFirma !== FIPGL23_ID && <option value="kurumsal">Kurumsal</option>}
                      </>
                    )}
                  </select>
                  {seciliFirma === BROILER_ID && (
                    <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>
                      Adım 1'de seçilen: {form.broiler_satis_tipi === 'ciftlik' ? '🐔 Çiftlik' : form.broiler_satis_tipi === 'bayi' ? '🏪 Bayi' : '🏭 Entegre Tesis'}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="label">Ödeme Türü</label>
                  <select className="select" value={form.odeme_turu} onChange={e => setForm(f => ({ ...f, odeme_turu: e.target.value }))}>
                    {seciliFirma === BROILER_ID ? (
                      <>
                        <option value="banka">Banka Havalesi</option>
                        <option value="elden">Elden / Nakit</option>
                        <option value="kredi_karti">Kredi Kartı</option>
                        <option value="cek">Çek</option>
                        <option value="senet">Senet</option>
                      </>
                    ) : seciliFirma === FIPGL23_ID ? (
                      <>
                        <option value="banka">Banka Havalesi (KDV'siz)</option>
                        <option value="elden">Elden / Nakit (KDV'siz)</option>
                      </>
                    ) : (
                      <>
                        <option value="banka">Banka Havalesi (KDV'siz)</option>
                        <option value="elden">Elden / Nakit (KDV'siz)</option>
                        <option value="kredi_karti">Kredi Kartı (KDV'li)</option>
                      </>
                    )}
                  </select>
                </div>

                <div className="form-group">
                  <label className="label">Kargo Takip No</label>
                  <input className="input" value={form.kargo_kodu} onChange={e => setForm(f => ({ ...f, kargo_kodu: e.target.value }))} placeholder="Kargo takip numarası..." autoComplete="off" />
                </div>
              </div>

              <div className="form-group">
                <label className="label">Teslimat Adresi</label>
                <textarea className="textarea" value={form.adres} onChange={e => setForm(f => ({ ...f, adres: e.target.value }))} placeholder="Teslimat adresi..." />
              </div>
              <div className="form-group">
                <label className="label">Not</label>
                <textarea className="textarea" value={form.not_} onChange={e => setForm(f => ({ ...f, not_: e.target.value }))} />
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                <input type="checkbox" checked={form.fatura_durumu} onChange={e => setForm(f => ({ ...f, fatura_durumu: e.target.checked }))} />
                <span>Fatura Kesildi</span>
              </label>
              {(profil?.rol !== 'temsilci' || profil?.numune_yetkisi) && (
                <>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                    <input type="checkbox"
                      checked={form.siparis_tipi === 'numune'}
                      onChange={e => setForm(f => ({ ...f, siparis_tipi: e.target.checked ? 'numune' : 'normal' }))} />
                    <span style={{ color: form.siparis_tipi === 'numune' ? '#8b5cf6' : 'inherit', fontWeight: form.siparis_tipi === 'numune' ? 600 : 400 }}>
                      🎁 Numune Siparişi
                    </span>
                  </label>
                  {form.siparis_tipi === 'numune' && (
                    <div style={{ padding: '8px 12px', background: 'rgba(139,92,246,0.1)', border: '1px solid rgba(139,92,246,0.3)', borderRadius: 'var(--r)', fontSize: 12, color: '#8b5cf6' }}>
                      Komisyon hesaplanmayacak. Stoktan düşülecek.
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>

        {/* SEPET */}
        <div>
          <div className="card" style={{ position: 'sticky', top: 20 }}>
            <h3 style={{ marginBottom: 12, fontSize: 15, fontWeight: 700 }}>Sepet ({sepet.length} ürün)</h3>
            {sepet.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: 'var(--text2)', fontSize: 13 }}>Henüz ürün eklenmedi</div>
            ) : (
              <>
                {sepet.map(({ urun, miktar, fiyat, grup, odemeTuru }) => (
                  <div key={urun.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                    <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>{urun.ad}</div>
                    <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 6 }}>
                      {grup === 'hasta_yakini' ? '🏥 Hasta Yakını' : '🩺 Veteriner'}
                      {odemeTuru === 'kredi_karti' ? ' • 💳 KDV\'li' : odemeTuru === 'banka' ? ' • 🏦 KDV\'siz' : ''}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <button className="btn btn-ghost btn-sm" onClick={() => sepetMiktarGuncelle(urun.id, miktar - 1)}>−</button>
                      <input type="number" className="input" style={{ width: 60, textAlign: 'center' }} value={miktar} onChange={e => sepetMiktarGuncelle(urun.id, e.target.value)} min={1} />
                      <button className="btn btn-ghost btn-sm" onClick={() => sepetMiktarGuncelle(urun.id, miktar + 1)}>+</button>
                      <button className="btn btn-danger btn-sm" onClick={() => sepetMiktarGuncelle(urun.id, 0)}>✕</button>
                      <span style={{ marginLeft: 'auto', fontWeight: 600, fontSize: 13 }}>{(fiyat * miktar).toLocaleString('tr-TR')} ₺</span>
                    </div>
                  </div>
                ))}
                <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                    <span style={{ color: 'var(--text2)' }}>Toplam Tutar</span>
                    <span style={{ fontWeight: 700 }}>{tutar.toLocaleString('tr-TR')} ₺</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                    <span style={{ color: 'var(--text2)' }}>
                      Komisyon{altTemsilciOran !== null ? <span style={{ fontSize: 11 }}> (%{altTemsilciOran} payın)</span> : ''}
                    </span>
                    <span style={{ color: 'var(--yellow)' }}>{komisyonGoster.toLocaleString('tr-TR')} ₺</span>
                  </div>
                  {!isTemsilci && (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                        <span style={{ color: 'var(--text2)' }}>Maliyet</span>
                        <span style={{ color: 'var(--red)' }}>-{maliyet.toLocaleString('tr-TR')} ₺</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, borderTop: '1px solid var(--border)', paddingTop: 8 }}>
                        <span style={{ color: 'var(--text2)', fontWeight: 700 }}>Net Kar</span>
                        <span style={{ color: kar >= 0 ? 'var(--green)' : 'var(--red)', fontWeight: 700 }}>{kar.toLocaleString('tr-TR')} ₺</span>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            <div style={{ marginTop: 16 }}>
              {adim === 1 ? (
                <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
                  onClick={() => {
                    if (!form.depo_id) { setHata('Lütfen depo seçin!'); return; }
                    if (sepet.length === 0) { setHata('Sepet boş!'); return; }
                    setAdim(2); setHata('');
                  }}
                  disabled={sepet.length === 0}>
                  Devam Et →
                </button>
              ) : (
                <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={handleKaydet} disabled={yukleniyor}>
                  {yukleniyor ? 'Kaydediliyor...' : '✓ Sipariş Oluştur'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
